interface State {
  appealComment: string
  appealRemainingTime: string
  appealTime: {}
  isVideoWaiting: number
  isVoiceWaiting: number
  isNozokiWaiting: number
  possibleTimes: number[]
}

const defaultState: State = {
  appealComment: '',
  appealRemainingTime: '',
  appealTime: {},
  isVideoWaiting: 0,
  isVoiceWaiting: 0,
  isNozokiWaiting: 0,
  possibleTimes: []
}

const state: State = Object.assign({}, defaultState)

const mutations = {
  resetState(state: State) {
    const s = defaultState
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  setAppealComment(state: State, appealComment: string) {
    state.appealComment = appealComment
  },
  setAppealRemainingTime(state: State, appealRemainingTime: string) {
    state.appealRemainingTime = appealRemainingTime
  },
  setAppealTime(state: State, appealTime: {}) {
    state.appealTime = appealTime
  },
  setIsVideoWaiting(state: State, isVideoWaiting: number) {
    state.isVideoWaiting = isVideoWaiting
  },
  setIsVoiceWaiting(state: State, isVoiceWaiting: number) {
    state.isVoiceWaiting = isVoiceWaiting
  },
  setIsNozokiWaiting(state: State, isNozokiWaiting: number) {
    state.isNozokiWaiting = isNozokiWaiting
  },
  setPossibleTimes(state: State, possibleTimes: any[]) {
    state.possibleTimes = possibleTimes
  }
}

const actions = {}

const getters = {
  appealComment: (state: State): string => state.appealComment,
  appealRemainingTime: (state: State): string => state.appealRemainingTime,
  appealTime: (state: State): {} => state.appealTime,
  isVideoWaiting: (state: State): number => state.isVideoWaiting,
  isVoiceWaiting: (state: State): number => state.isVoiceWaiting,
  isNozokiWaiting: (state: State): number => state.isNozokiWaiting,
  possibleTimes: (state: State): number[] => state.possibleTimes
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
